module.exports = __webpack_public_path__ + "img/panking_2@3x.256557fa.png";